"use client";

import { useMarket } from "@app/_context";
import { useQuery } from "@tanstack/react-query";

import { getCartCookie } from "@/utils/cart/getCartCookie";

import { checkoutQueryKeys } from "../config/queryKeys";
import { getCheckout } from "../service/getCheckout";
import { useCheckoutContext } from "./useCheckoutContext";

export function useCheckout() {
  const marketConfig = useMarket().state.market;
  const { initialCheckout } = useCheckoutContext();
  const cartCookie = getCartCookie();

  return useQuery({
    queryKey: checkoutQueryKeys.checkout(cartCookie?.id),
    queryFn: () =>
      getCheckout({
        locale: marketConfig.serviceLocale,
        cartId: cartCookie?.value ?? "",
      }),
    initialData: initialCheckout ?? undefined,
    retry: 1,
    enabled: Boolean(cartCookie?.id),
  });
}
